import { useContext } from 'react';
import { ContainerContext } from '../containers/ContainerContext';

export const useContainerProps = props => {
  return { ...useContext(ContainerContext), ...props };
};
